import React from 'react'
import { Menu, MenuItem } from '@mui/material'

function VisitContextMenu({ mouseX, mouseY, onClose, openVisitEditor, openStockItemEditor, openClinicEditor, openAssessmentEditor, confirmDeleteVisit, isAdmin }) {
  const open = mouseY !== null
  const anchorPosition = open && mouseX !== null ? { top: mouseY, left: mouseX } : undefined

  return (
    <Menu
      keepMounted
      open={open}
      onClose={onClose}
      anchorReference="anchorPosition"
      anchorPosition={anchorPosition}
    >
      <MenuItem onClick={openVisitEditor}>Visit Info</MenuItem>
      <MenuItem onClick={openStockItemEditor}>Stock Sheet</MenuItem>
      <MenuItem onClick={openClinicEditor}>Clinical Record</MenuItem>
      <MenuItem onClick={openAssessmentEditor}>Wound Assessment</MenuItem>
      {isAdmin && <MenuItem>---------------</MenuItem>}
      {isAdmin && <MenuItem onClick={confirmDeleteVisit}>Delete Visit</MenuItem>}
    </Menu>
  )
}

export default VisitContextMenu
